import { render, staticRenderFns } from "./VencimentoCCBsGeral.vue?vue&type=template&id=5b3abaaf&"
import script from "./VencimentoCCBsGeral.vue?vue&type=script&lang=js&"
export * from "./VencimentoCCBsGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports